"use client";

import DrawLogo from "@components/atoms/DrawLogo";
import Link from "next/link";
import { Suspense } from "react";

const HomePage = () => {
  return (
    <Suspense fallback={<div>Getting ready...</div>}>
      <main className="w-full h-dvh flex flex-col justify-center items-center">
        <Link
          className="flex flex-col justify-center items-center text-2xl p-16"
          href="/uploadxlsx"
        >
          <DrawLogo />
          <p className="text-sm mt-4">Click here to start</p>
        </Link>
      </main>
    </Suspense>
  );
};

export default HomePage;
